<div class="footer-links d-flex align-items-center flex-wrap justify-content-center">
  <a (click)="navigateToSupportCenter()" class="{{ sizeClass }} pointer-cursor">
    {{ 'SUPPORT_CENTER' | translate }}
  </a>

  <a (click)="navigateToProduct()" class="{{ sizeClass }} pointer-cursor">
    {{ 'PRODUCTS' | translate }}
  </a>

  <a (click)="navigateToApps()" class="{{ sizeClass }} pointer-cursor">
    Apps
  </a>

  <a (click)="navigateToTermsOfService()" class="{{ sizeClass }} pointer-cursor">
    {{ 'TERMS_OF_SERVICE' | translate }}
  </a>

  <a (click)="navigateToTermsOfUse()" class="{{ sizeClass }} pointer-cursor">
    {{ 'TERMS_OF_USE' | translate }}
  </a>

  <a (click)="navigateToPrivacyPolicy()" class="{{ sizeClass }} pointer-cursor">
    {{ 'PRIVACY_POLICY' | translate }}
  </a>

  <a (click)="openVersionInfo()" class="{{ sizeClass }} pointer-cursor">
    {{ 'VERSION_INFO' | translate }}
  </a>

  <a (click)="navigateToWebAccessibilty()" class="{{ sizeClass }} pointer-cursor">
    {{ 'WEB_ACCESSIBILITY' | translate }}
  </a>

</div>

<div class="footer-links d-flex align-items-center flex-wrap justify-content-center">
  <span class="{{ sizeClass }} ml-1">
    <span [ngClass]="sizeClass !== 'footerTextXs' ? 'break-row' : 'hide'"></span>
    {{ copyRights }}
  </span>
</div>
